/* eslint-disable */
<template>
	<section>
		<div class="edit-window" v-if="showContactEdit">
			<div class="title">Kontaktdaten bearbeiten</div>
			<div>
				<label class="label">E-Mail</label>
				<div class="control">
					<input class="input" ref="email" type="text" v-model="booking.email" placeholder>
				</div>
			</div>
			<div>
				<label class="label">Mobiltelefon</label>
				<div class="control">
					<input class="input" type="number" v-model="booking.telephone" placeholder>
				</div>
			</div>
			<div class="button-wrap">
				<button class="button" v-on:click="saveContactDetails">Speichern</button>
			</div>
		</div>
		<div class="smaller-heading">Zusammenfassung</div>
		<div class="text">
			<p>Prüfen Sie Ihre Buchungsangaben</p>
		</div>
		<div class="columns summary">
			<div class="column is-one-third background-box">
				<div class="">
					<div class="roomType">{{booking.firstname}} {{booking.lastname}}</div>
					<div class="columns" style="margin-bottom:0em;">
						<div class="column is-half">Email:</div>
						<div class="column is-half" v-if="booking.email">{{booking.email}}</div>
						<div class="column is-half no-input" v-if="!booking.email">Keine Angabe</div>
					</div>
					<div class="columns">
						<div class="column is-half">Mobiltelefon:</div>
						<div class="column is-half" v-if="booking.telephone">{{booking.telephone}}</div>
						<div class="column is-half no-input" v-if="!booking.telephone">Keine Angabe</div>
					</div>
					<!-- <div class="missing-information" v-if="!booking.email">Keine Emailadresse</div>
        <div class="missing-information" v-if="!booking.telephone">Keine Telefonnummer</div>
					<div>{{booking.telephone}}</div>-->
					<div>
						<button class="button edit-button" v-on:click="showContactEdit = true" style="margin-left: 0;margin-top: 0;margin-bottom: 4em;">Bearbeiten</button>
					</div>
					<div>Mit diesen Daten können wir Sie kontaktieren sollten Sie Ihren Zimmercode verlieren.</div>
					<!-- <div>An diese Email wird Ihre Rechnung versendet.</div> -->
				</div>
			</div>
			<div class="column is-two-thirds background-box">
				<!-- <div class="roomType">{{booking.room.roomSetting.name}}</div> -->
				<div class="columns" style="border-bottom:1px solid gray; font-weight:bold;">
					<div class="column is-three-fifths no-padding">Buchung</div>
					<div
						class="column  no-padding"
					>Einzelpreis</div><div
						class="column  no-padding"
					>Preis</div>
				</div>
				<div>
					<div v-for="room of booking.rooms">
						<div class="columns" style="border-bottom:1px solid gray;">
							<div class="column is-three-fifths ">{{room.room.roomSetting.name}}
								<div style="font-size:0.8em;">
									<strong>{{bookedDays(room)}} Nächte</strong> {{room.arrival_date | moment("DD.MM.")}} - {{room.departure_date | moment("DD.MM.YYYY")}}
								</div>
							</div>
							<div
								class="column "
							>{{formatPrice(room.room.roomSetting.price)}}€</div><div
								class="column "
							>{{formatPrice(priceOneRoom(room))}}€</div>
						</div>
					</div>
					<div class="columns" style="padding-top:1em;">
						<div class="column is-four-fifths ">7% MwSt.</div>
						<!-- <div class="column is-four-fifths ">5% MwSt.</div> -->
						<div class="column ">{{formatPrice(calculatedVat)}}€</div>
					</div>
					<div class="columns">
						<div class="column is-four-fifths no-padding-top">Netto</div>
						<div class="column no-padding-top">{{formatPrice(priceWithoutVat)}}€</div>
					</div>
					<div class="columns border">
						<div class="column is-four-fifths">Zu bezahlen</div>
						<div class="column ">{{formatPrice(booking.price)}}€</div>
					</div>
					<div>
						<img class="accepted-payment" src="/static/visa_pos_fc.png" alt>
						<img class="accepted-payment" src="/static/ms_vrt_opt_pos_73_3x.png" alt>
						<img class="accepted-payment" src="/static/mc_ec.png" alt>
						<img class="accepted-payment" src="/static/contactless_ind_pos.png" alt>
						<img class="accepted-payment" src="/static/GooglePay_mark_800_gray_3x.png" alt>
						<img class="accepted-payment" src="/static/Apple_Pay_Mark_RGB_LARGE_052318.png" alt>
					</div>
				</div>
			</div>
		</div>

		<div class="back-button">
			<button class="button" v-on:click="goBack">Zurück</button>
		</div>
		<div class="next-button">
			<!-- <button class="button" v-on:click="dev_pay">**BEZAHLT**</button> -->
			<button class="button" v-on:click="startPayment">Bezahlen</button>
		</div>
	</section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

export default {
	name: 'Summary',

	components: {},

	data () {
		return {
			showContactEdit: false
		}
	},

	computed: {
		calculatedVat () {
			return (this.booking.price / 107) * 7
			// return (this.booking.price / 105) * 5
		},
		booking () {
			return this.$store.state.booking
		},
		priceWithoutVat () {
			return this.booking.price - this.calculatedVat
		}
	},

	created () {
		//   this.$refs.email.$el.focus()
		// this.$nextTick(() => this.$refs.email.focus())
		// this.fetchData();
		var that = this
		window.addEventListener('returnPayment', function () {
			console.log('test')
			that.returnPayment()
		})
	},

	methods: {
		priceOneRoom (room) {
			return this.bookedDays(room) * room.room.roomSetting.price
		},
		bookedDays (room) {
			return Math.abs(
				moment(room.arrival_date).diff(
					moment(room.departure_date),
					'days'
				)
			)
		},
		formatPrice (value) {
			let val = (value / 1).toFixed(2).replace('.', ',')
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
		},

		startPayment () {
			var booking = this.$store.state.booking
			window.webkit.messageHandlers['startPayment'].postMessage({
				booking_id: booking._id,
				price: this.booking.price,
				booking: this.booking
			})
		},
		returnPayment () {
			console.log('called')
			this.$router.push('thankyou')
		},
		dev_pay () {
			var booking = this.$store.state.booking
			window.webkit.messageHandlers['issuePayment'].postMessage({
				booking_id: booking._id,
				booking: this.booking
			})
		},
		goBack () {
			this.$router.push('bookingCode')
		},
		changeContactData () {
			this.showEditWindow = true
		},
		saveContactDetails () {
			axios
				.post(
					process.env.API_URL +
						'/booking/contact-change/' +
						this.booking._id,
					{ booking: this.booking }
				)
				.then(response => {
					this.booking = response.data
					this.showContactEdit = false
				})
				.catch(err => {
					console.log(err)
				})
		},
		createBooking () {
			// var booking = this.$store.state.booking

			// axios
			//   .post(
			//     "http://holzheim.thiscounts.io:3000/booking/create/backend",
			//     {booking: booking}
			//   )
			//   .then(resp => {

			//     console.log(resp);
			//     this.$router.push('thankyou')
			//   })
			//   .catch(err => {
			//     console.log(err);
			//   });npm insta
		}
	}
}
</script>
<style scoped>
.smaller-heading {
	margin-top: 0.5em;
}
.summary {
	font-size: 1.3em;
	margin-left: 2em;
	margin-right: 2em;
	margin-top:2em;
}
.roomType {
	font-weight: bold;
	font-size: 1.25em;
	margin-top: 1em;
}
.border {
	border-top: 2px solid black;
	font-weight: bold;
}
.no-input {
	color:gray;
}
.no-padding {
	padding-bottom: 0 !important;
}
.no-padding-top {
	padding-top: 0 !important;
}
.personal_wrapper {
	margin-top: 1em;
}
.night_price {
	margin-bottom: 0.5em;
}
.edit-button {
	font-size: 16px;
}
.accepted-payment {
	height: 50px;
	margin-right: 0.25em;
}

.background-box {
	background: #ffffffe3;
	padding-left: 3em;
	padding-right: 3em;
	padding-bottom: 3em;
	padding-top: 1.5em;
	border-radius: 5px;
	color: black;
}
.edit-window {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 999999;
	padding: 3em;
}

.edit-window .input,
.edit-window .taginput .taginput-container.is-focusable,
.edit-window .textarea {
	background-color: white;
	border-color: #dbdbdb;
	color: #363636;
	-webkit-box-shadow: none;
	box-shadow: none;
	max-width: 100%;
	width: 100%;
	border: 2px solid #808e9b;
	color: #1e272e;
	font-size: 1.3em;
	font-family: "Valera Round", sans-serif;
}

.edit-window .label {
	font-weight: 500;
	font-size: 1.3em;
	color: #808e9b;
	margin-top: 1em;
}
.edit-window button {
	font-size: 1.5em;
	margin: 0 auto;
	width: 300px;
}
.edit-window .button-wrap {
	text-align: center;
	margin-top: 3em;
}
.edit-window .title {
	font-size: 2em;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Summary.vue